<template>
    <v-dialog
        v-model="$store.state.concil.reports.StmtSumByDateRange"
        transition="dialog-bottom-transition"
        persistent
        width="1800"
    >
        <v-container 
            fluid
            style="padding: 0;overflow: hidden;"
        >
            <v-card>
                <v-toolbar dark color="secondary" dense style="margin-bottom: 15px;">
                    <v-btn
                        icon
                        dark
                        @click="getReport('xlsx')"
                    >
                        <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        dark
                        @click="getReport('pdf')"
                    >
                        <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                    <v-switch
                        v-model="showGroupByInvoice"
                        inset
                        label="Group by invoice"
                        hide-details
                        style="margin-left: 15px;"
                    ></v-switch>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        {{ ReportData.Params.Report.Name }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div style="width: 198px;height: 50px;margin-right: 15px;"></div>
                    <div style="width: 48px;height: 48px;"></div>
                    <v-btn
                        icon
                        dark
                        @click="$store.state.concil.reports.StmtSumByDateRange = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-row style="padding: 0 20px 30px;">
                    <v-col cols="12">
                        <v-card outlined v-if="render">
                            <v-card-title style="padding: 30px 50px 30px 15px;">
                                <v-text-field
                                    v-model="reportSearch"
                                    append-icon="mdi-magnify"
                                    label="Search here"
                                    hide-details
                                    style="padding-top: 0;margin-top: 0;margin-left: 30px;"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-switch
                                    v-model="singleExpand"
                                    label="Single expand"
                                    class="mt-2"
                                    hide-details
                                ></v-switch>
                            </v-card-title>
                            <v-data-iterator
                                :items="showGroupByInvoice ? fmtReportData.Data.ByInvoice : fmtReportData.Data.ByFile"
                                :search="reportSearch"
                                :single-expand="singleExpand"
                                :item-key="showGroupByInvoice ? 'InvId' : 'PmtId'"
                                dense
                                style="padding: 0 30px;"
                            >
                                <template v-slot:default="{ items, isExpanded, expand }">
                                    <v-card outlined>
                                        <v-row>
                                            <v-col cols="12">
                                                <table class="general-tbl">
                                                    <tr 
                                                        class="grid-container" 
                                                        style="background-color: #adbbcc;"
                                                        v-if="showGroupByInvoice"
                                                    >
                                                        <th style="background-color: #adbbcc;border: unset;padding: 6px 0;"></th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">InvId</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">InvDate</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">InvTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">UptTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtBOLTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">FSC</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">Diff</th>
                                                    </tr>
                                                    <tr 
                                                        class="grid-container" 
                                                        style="background-color: #adbbcc;"
                                                        v-else
                                                    >
                                                        <th style="background-color: #adbbcc;border: unset;padding: 6px 0;"></th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">Filename</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtId</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtDate</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">UptTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtBOLTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">FSC</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">PmtTotal</th>
                                                        <th style="border: unset;padding-left: 0;padding: 6px 0;">Diff</th>
                                                    </tr>
                                                </table>
                                            </v-col>
                                        </v-row>
                                        <row 
                                            v-for="(mainItem, idx) in items" 
                                            :key="showGroupByInvoice ? mainItem.InvId : mainItem.PmtId"
                                        >
                                            <v-col cols="12" style="padding: 0;">
                                                <table class="general-tbl-data">
                                                    <tr 
                                                        class="grid-container"
                                                        :style="idx % 2 === 0 ? 'background-color: #ebf3fd;border-bottom: 1px solid #bababa;' : 'background-color: #fff;border-bottom: 1px solid #bababa;'"
                                                        v-if="showGroupByInvoice"
                                                    >
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">
                                                            <v-btn
                                                                @click="expand(mainItem, !isExpanded(mainItem))"
                                                                dense
                                                                icon
                                                            >
                                                                <v-icon v-if="isExpanded(mainItem)" dense>mdi-chevron-up</v-icon>
                                                                <v-icon v-else dense>mdi-chevron-down</v-icon>
                                                            </v-btn>
                                                        </th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.InvId }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.InvDate }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.InvTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.UptTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtBOLTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtFSC }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.Diff }}</th>
                                                    </tr>
                                                    <tr 
                                                        class="grid-container"
                                                        :style="idx % 2 === 0 ? 'background-color: #ebf3fd;border-bottom: 1px solid #bababa;' : 'background-color: #fff;border-bottom: 1px solid #bababa;'"
                                                        v-else
                                                    >
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">
                                                            <v-btn
                                                                @click="expand(mainItem, !isExpanded(mainItem))"
                                                                dense
                                                                icon
                                                            >
                                                                <v-icon v-if="isExpanded(mainItem)" dense>mdi-chevron-up</v-icon>
                                                                <v-icon v-else dense>mdi-chevron-down</v-icon>
                                                            </v-btn>
                                                        </th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.Filename }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtId }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtDate }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.UptTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtBOLTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtFSC }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.PmtTotal }}</th>
                                                        <th :style="idx % 2 === 0 ? 'background-color: #ebf3fd;' : 'background-color: #fff;'">{{ mainItem.Diff }}</th>
                                                    </tr>
                                                </table>
                                                <v-card outlined v-if="isExpanded(mainItem)" style="background-color: #D6EAF8 ;" class="card-sub-tbl">
                                                    <v-card-title style="padding-top: 5px;">
                                                        <v-text-field
                                                            v-model="subReportSearch"
                                                            append-icon="mdi-magnify"
                                                            label="Search here"
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-card-title>
                                                    <v-data-table
                                                        class="sub-tbl"
                                                        :headers="showGroupByInvoice ? subHeaders.ByInvoice : subHeaders.ByFile"
                                                        :items="mainItem.Payments"
                                                        :search="subReportSearch"
                                                        dense
                                                    >
                                                        <template slot="body.append">
                                                            <tr>
                                                                <td colspan="3"></td>
                                                                <td class="text-left font-weight-bold">{{ mainItem.UptTotal }}</td>
                                                                <td class="text-left font-weight-bold">{{ mainItem.PmtBOLTotal }}</td>
                                                                <td class="text-left font-weight-bold">{{ mainItem.PmtFSC }}</td>
                                                                <td class="text-left font-weight-bold">{{ mainItem.PmtTotal }}</td>
                                                                <td class="text-left font-weight-bold">{{ mainItem.Diff }}</td>
                                                            </tr>
                                                        </template>
                                                    </v-data-table>
                                                </v-card>
                                            </v-col>
                                        </row>
                                    </v-card>
                                </template>
                            </v-data-iterator>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from "axios";
//import * as XLSX from 'xlsx';

export default {
    props: ['ReportData'],
    components: {

    },
    data: function () {
        return {
            reportSearch: '',
            subReportSearch: '',
            singleExpand: true,
            expanded: [],
            subHeaders: {
                ByInvoice: [
                    { text: "Filename", value: "Filename" },
                    { text: "PmtId", value: "PmtId" },
                    { text: "PmtDate", value: "PmtDate" },
                    { text: "UptTotal", value: "UptTotal" },
                    { text: "PmtBOLTotal", value: "PmtBOLTotal" },
                    { text: "PmtFSC", value: "PmtFSC" },
                    { text: "PmtTotal", value: "PmtTotal" },
                    { text: "Diff", value: "Diff" },
                ],
                ByFile: [
                    { text: "InvId", value: "InvId" },
                    { text: "InvDate", value: "InvDate" },
                    { text: "InvTotal", value: "InvTotal" },
                    { text: "UptTotal", value: "UptTotal" },
                    { text: "PmtBOLTotal", value: "PmtBOLTotal" },
                    { text: "PmtFSC", value: "PmtFSC" },
                    { text: "PmtTotal", value: "PmtTotal" },
                    { text: "Diff", value: "Diff" },
                ]
            },
            showGroupByInvoice: false,
            docHeaders: {
                ByFile: {
                    First: [
                        'PmtId',
                        'Filename',
                        'PmtDate',
                    ],
                    Second: [
                        'InvId',
                        'InvDate',
                        'InvTotal',
                        'UptTotal',
                        'PmtBOLTotal',
                        'PmtFSC',
                        'PmtTotal',
                        'Diff',
                    ],
                    Totals: [
                        'UptTotal',
                        'PmtBOLTotal',
                        'PmtFSC',
                        'PmtTotal',
                        'Diff',
                    ]
                },
                ByInvoice: {
                    First: [
                        'InvId',
                        'InvDate',
                        'InvTotal'
                    ],
                    Second: [
                        'PmtId',
                        'Filename',
                        'PmtDate',
                        'UptTotal',
                        'PmtBOLTotal',
                        'PmtFSC',
                        'PmtTotal',
                        'Diff',
                    ],
                    Totals: [
                        'UptTotal',
                        'PmtBOLTotal',
                        'PmtFSC',
                        'PmtTotal',
                        'Diff',
                    ]
                },
            },
            filename: '',
            render: false,
            fmtReportData: {}
        }
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        prepareData: function () {
            // Convert payments array
            for (let version in this.ReportData.Data) {
                this.ReportData.Data[version].forEach(group => {
                    group.Payments = JSON.parse(group.Payments);
                });
            }
            
            console.log(this.ReportData.Data);
            this.formatData();
        },
        formatData: function () {
            this.fmtReportData = JSON.parse(JSON.stringify(this.ReportData));
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
            });

            for (let version in this.fmtReportData.Data) {
                this.fmtReportData.Data[version].forEach(group => {
                    if (group.Payments.length) {
                        group.UptTotal = cad.format(group.UptTotal);
                        group.PmtTotal = cad.format(group.PmtTotal);
                        group.PmtBOLTotal = cad.format(group.PmtBOLTotal);
                        group.PmtFSC = cad.format(group.PmtFSC);
                        group.Diff = cad.format(group.Diff);
                        group.Payments.forEach(pmt => {
                            pmt.UptTotal = cad.format(pmt.UptTotal);
                            pmt.PmtTotal = cad.format(pmt.PmtTotal);
                            pmt.PmtBOLTotal = cad.format(pmt.PmtBOLTotal);
                            pmt.PmtFSC = cad.format(pmt.PmtFSC);
                            pmt.Diff = cad.format(pmt.Diff);
                            if (version == 'ByFile' && pmt.InvTotal != 'Unapplied') {
                                pmt.InvTotal = cad.format(pmt.InvTotal);
                            }
                        });

                        if (version == 'ByInvoice' && group.InvTotal != 'Unapplied') {
                            group.InvTotal = cad.format(group.InvTotal);
                        }
                    }
                });
            }

            console.log(this.fmtReportData);
            this.render = true;
        },
        setParams: function (requestType) {
            // Set doc headers and data
            let version = "";
            let headers = [];
            let data = [];
            if (requestType == 'xlsx' && this.showGroupByInvoice) {
                headers = this.docHeaders.ByInvoice;
                data = this.ReportData.Data.ByInvoice;
                version = 'by-invoice';
            } else if (requestType == 'xlsx' && !this.showGroupByInvoice) {
                headers = this.docHeaders.ByFile;
                data = this.ReportData.Data.ByFile;
                version = 'by-file';
            } else if (requestType == 'pdf' && this.showGroupByInvoice) {
                headers = this.docHeaders.ByInvoice;
                data = this.fmtReportData.Data.ByInvoice;
                version = 'by-invoice';
            } else if (requestType == 'pdf' && !this.showGroupByInvoice) {
                headers = this.docHeaders.ByFile;
                data = this.fmtReportData.Data.ByFile;
                version = 'by-file';
            }
            console.log(headers);

            let params = {
                Customer: this.ReportData.Params.Customer,
                Report: this.ReportData.Params.Report,
                SearchBy: this.ReportData.Params.SearchBy,
                Data: data,
                Headers: headers,
                Version: version,
            };

            if (this.ReportData.Params.SearchBy == 'date-range') {
                this.filename = "Rec_" + this.ReportData.Params.Customer.Alias + "_" + this.ReportData.Params.Report.Alias + "_" + this.ReportData.Params.StartDate + "_" + this.ReportData.Params.EndDate;
                params.StartDate = this.ReportData.Params.StartDate;
                params.EndDate = this.ReportData.Params.EndDate;
            } else if (this.ReportData.Params.SearchBy == 'file') {
                this.filename = "Rec_" + this.ReportData.Params.Customer.Alias + "_" + this.ReportData.Params.Report.Alias;
                params.File = this.ReportData.Params.File;
            }

            this.filename = this.showGroupByInvoice ? this.filename + "_GroupedByInvoice." + requestType : this.filename + "_GroupedByFile." + requestType;
            params.Filename = this.filename;

            console.log(params);
            return params;
        },
        getReport: async function (requestType) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = this.setParams(requestType);
            await axios
                .post('conciliation/get/report/' + requestType, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob',
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
    },
};
</script>

<style>
    .general-tbl, .general-tbl-data {
        border-collapse: collapse;
        width: 100%;
    }
    .general-tbl th, .general-tbl-data th {
        /* padding: 4px 8px; */
        text-align: left;
        font-size: 12px;
    }
    .general-tbl th:hover {
        background-color: #7892b1;
    }
    .general-tbl-data th { 
        background-color: #fff;
        font-weight: 500;
    }

    .sub-tbl th, .sub-tbl td {
        padding: 8px;
        text-align: left;
    }
    .sub-tbl th {
        font-size: 12px;
        background-color: #fff;
    }
    .sub-tbl td:hover {
        background-color: #e1e1e1;
    }
    .grid-container {
        display: grid;
        grid-template-columns: 1fr 3fr 3fr 3fr 3fr 3fr 3fr 3fr 3fr;
        align-items: center;
    }
    .card-sub-tbl .sub-tbl .v-data-footer {
        background-color: #D6EAF8 ;
    }
    .theme--dark.v-label {
        color: hsla(0,0%,100%,.7)!important;
    }
    .theme--light.v-label {
        color: rgba(0,0,0,.6)!important;
    }
</style>